import React, {
  useEffect,
  useState,
} from "react";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  useHistory,
  useParams,
} from "react-router-dom";

import {
  Button,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
} from "react-leaflet";

import PageLayout from "../../../components/PageLayout/PageLayout";

import { voivodeships as vvship } from "../../../stuffs/Voivodeships";

import { AppDispatch } from "../../../app/store";

import {
  getAdminOfferById,
  updateAdminOfferOwner,
  updateAdminOfferCompanyData,
  updateAdminOfferAddress,
  activateAdminOffer,
  deactivateAdminOffer,
  activateAdminOfferFreePeriod,
  updateAdminOfferServices,
  updateAdminOfferDescription,
  grantAdminOfferBenefit,
  selectAdminOffer,
  selectAdminOffersLoading,
  selectAdminOffersError,
} from "../../../slices/adminOffer/adminOfferSlice";

import {
  getAdminUsers,
  selectAdminUsers,
} from "../../../slices/adminUser/adminUserSlice";

import { icons } from "../../../stuffs/Icons";
import { mapIcons } from "../../../stuffs/MapIcons";

import styles from "./OfferDetails.module.css";

interface RouteParams {
  id: string;
}

const OfferDetails: React.FC = () => {
  const { id } =
    useParams<RouteParams>();

  const history = useHistory();

  const dispatch =
    useDispatch<AppDispatch>();

  /*
   * REDUX
   */

  const offer = useSelector(
    selectAdminOffer
  );

  const users = useSelector(
    selectAdminUsers
  );

  const loading = useSelector(
    selectAdminOffersLoading
  );

  const error = useSelector(
    selectAdminOffersError
  );

  /*
   * WŁAŚCICIEL
   */

  const [
    ownerModalOpen,
    setOwnerModalOpen,
  ] = useState(false);

  const [
    ownerEmail,
    setOwnerEmail,
  ] = useState("");

  const [
    ownerError,
    setOwnerError,
  ] = useState("");

  const [
    savingOwner,
    setSavingOwner,
  ] = useState(false);


  /*
   * DANE FIRMY
   */

  const [
    editingCompanyData,
    setEditingCompanyData,
  ] = useState(false);

  const [
    savingCompanyData,
    setSavingCompanyData,
  ] = useState(false);

  const [
    companyDataError,
    setCompanyDataError,
  ] = useState("");

  const [
    companyDataForm,
    setCompanyDataForm,
  ] = useState({
    name: "",
    shortName: "",
    email: "",
    phone: "",
    website: "",
  });

  /*
   * USŁUGI
   */

  const [editingServices, setEditingServices] =
    useState(false);

  const [savingServices, setSavingServices] =
    useState(false);

  const [servicesError, setServicesError] =
    useState("");

  const [servicesForm, setServicesForm] =
    useState({
      mainField: [] as string[],
      isADR: false,
      isInternational: false,
      isOversized: false,
    });

  /*
   * ADRES
   */

  const [
    editingAddress,
    setEditingAddress,
  ] = useState(false);

  const [
    savingAddress,
    setSavingAddress,
  ] = useState(false);

  const [
    addressError,
    setAddressError,
  ] = useState("");

  const [
    addressForm,
    setAddressForm,
  ] = useState({
    street: "",
    streetNumber: "",
    localNumber: "",
    zipCode: "",
    city: "",
    voivodeship: "",
  });

  /*
   * OPIS FIRMY
   */

  const [editingDescription, setEditingDescription] =
    useState(false);

  const [savingDescription, setSavingDescription] =
    useState(false);

  const [descriptionError, setDescriptionError] =
    useState("");

  const [descriptionForm, setDescriptionForm] =
    useState("");
  /*
   * MAPA
   */

  const [
    mapModalOpen,
    setMapModalOpen,
  ] = useState(false);

  /*
   * AKTYWACJA
   */

  const [
    activating,
    setActivating,
  ] = useState(false);

  const [
    activateError,
    setActivateError,
  ] = useState("");

  const [
    deactivating,
    setDeactivating,
  ] = useState(false);

  const [
    deactivateError,
    setDeactivateError,
  ] = useState("");

  const [
    activatingFreePeriod,
    setActivatingFreePeriod,
  ] = useState(false);

  const [
    freePeriodError,
    setFreePeriodError,
  ] = useState("");
  /*
   * BENEFITY
   */

  const [
    benefitForm,
    setBenefitForm,
  ] = useState({
    periodYears: 0,
    highlightedMonths: 0,
    recommendedMonths: 0,
    note: "",
  });

  const [
    grantingBenefit,
    setGrantingBenefit,
  ] = useState(false);

  const [
    benefitError,
    setBenefitError,
  ] = useState("");

  const [
    benefitSuccess,
    setBenefitSuccess,
  ] = useState("");
  /*
   * POBRANIE OFERTY
   */

  useEffect(() => {
    dispatch(
      getAdminOfferById(id)
    );
  }, [dispatch, id]);

  /*
   * HELPERY
   */

  const formatDate = (
    date:
      | string
      | null
      | undefined
  ) => {
    if (!date) {
      return "-";
    }

    return new Date(
      date
    ).toLocaleDateString(
      "pl-PL"
    );
  };

  const getStatus = () => {
    if (!offer) {
      return "-";
    }

    if (!offer.isActive) {
      return "Nieaktywna";
    }

    if (!offer.expirationDate) {
      return "Aktywna";
    }

    const now = new Date();

    const expiration =
      new Date(
        offer.expirationDate
      );

    if (
      expiration.getTime() <
      now.getTime()
    ) {
      return "Przedawniona";
    }

    const difference =
      expiration.getTime() -
      now.getTime();

    const daysLeft =
      Math.ceil(
        difference /
          (
            1000 *
            60 *
            60 *
            24
          )
      );

    if (daysLeft <= 30) {
      return "Wygasa wkrótce";
    }

    return "Aktywna";
  };

  const hasCoordinates =
    Array.isArray(
      offer?.coordinates
    ) &&
    offer!.coordinates.length === 2 &&
    offer!.coordinates.every(
      (coordinate) =>
        Number.isFinite(
          Number(coordinate)
        )
    );

  /*
   * WŁAŚCICIEL
   */

  const openOwnerModal = () => {
    setOwnerEmail(
      offer?.user || ""
    );

    setOwnerError("");

    setOwnerModalOpen(true);

    if (!users.length) {
      dispatch(
        getAdminUsers()
      );
    }
  };

  const closeOwnerModal = () => {
    if (savingOwner) {
      return;
    }

    setOwnerModalOpen(false);
    setOwnerError("");
  };

  const saveOwner =
    async () => {
      const email =
        ownerEmail
          .trim()
          .toLowerCase();

      if (!email) {
        setOwnerError(
          "Podaj adres e-mail właściciela"
        );

        return;
      }

      const emailRegex =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (
        !emailRegex.test(email)
      ) {
        setOwnerError(
          "Podaj poprawny adres e-mail"
        );

        return;
      }

      try {
        setSavingOwner(true);
        setOwnerError("");

        await dispatch(
          updateAdminOfferOwner({
            id,
            user: email,
          })
        ).unwrap();

        setOwnerModalOpen(false);
      } catch (err) {
        setOwnerError(
          typeof err === "string"
            ? err
            : "Nie udało się zmienić właściciela"
        );
      } finally {
        setSavingOwner(false);
      }
    };
  /*
   * DANE FIRMY
   */

  const startCompanyDataEdit = () => {
    if (!offer) {
      return;
    }

    setCompanyDataForm({
      name: String(offer.name || ""),
      shortName: String(offer.shortName || ""),
      email: String(offer.email || ""),
      phone: String(offer.phone || ""),
      website: String(offer.website || ""),
    });

    setCompanyDataError("");
    setEditingCompanyData(true);
  };

  const cancelCompanyDataEdit = () => {
    if (savingCompanyData) {
      return;
    }

    setEditingCompanyData(false);
    setCompanyDataError("");
  };

  const saveCompanyData = async () => {
    const name = companyDataForm.name.trim();
    const shortName = companyDataForm.shortName.trim();
    const email = companyDataForm.email.trim();
    const phone = companyDataForm.phone.trim();
    const website = companyDataForm.website.trim();

    if (
      !name ||
      !shortName ||
      !email ||
      !phone
    ) {
      setCompanyDataError(
        "Uzupełnij wymagane dane firmy"
      );
      return;
    }

    try {
      setSavingCompanyData(true);
      setCompanyDataError("");

      await dispatch(
        updateAdminOfferCompanyData({
          id,
          name,
          shortName,
          email,
          phone,
          website,
        })
      ).unwrap();

      setEditingCompanyData(false);
    } catch (err) {
      setCompanyDataError(
        typeof err === "string"
          ? err
          : "Nie udało się zapisać danych firmy"
      );
    } finally {
      setSavingCompanyData(false);
    }
  };
  /*
   * USLUGI
   */
  const startServicesEdit = () => {
  if (!offer) {
    return;
  }

  const recommendedIsActive = Boolean(
    offer.recommendedExpirationDate &&
      new Date(
        offer.recommendedExpirationDate
      ) > new Date()
  );

  if (recommendedIsActive) {
    const mainCategory =
      icons.find(
        (item) =>
          item.routing === offer.mainField?.[0]
      )?.title ||
      offer.mainField?.[0] ||
      "-";

    const confirmed = window.confirm(
      `Ta wizytówka ma aktywne TOP3.\n\n` +
        `Obecna główna kategoria (pierwsza na liście): ${mainCategory}.\n\n` +
        `Podczas edycji zmianie może ulec pierwsza kategoria, a tym samym kategoria przypisana do TOP3.\n\n` +
        `Czy chcesz przejść do edycji usług?`
    );

    if (!confirmed) {
      return;
    }
  }

  setServicesForm({
    mainField: [...(offer.mainField || [])],
    isADR: Boolean(offer.isADR),
    isInternational: Boolean(
      offer.isInternational
    ),
    isOversized: Boolean(
      offer.isOversized
    ),
  });

  setServicesError("");
  setEditingServices(true);
};

const cancelServicesEdit = () => {
  if (savingServices) {
    return;
  }

  setEditingServices(false);
  setServicesError("");
};

const toggleServiceCategory = (
  routing: string
) => {
  setServicesForm((current) => {
    const exists =
      current.mainField.includes(routing);

    return {
      ...current,
      mainField: exists
        ? current.mainField.filter(
            (field) => field !== routing
          )
        : [...current.mainField, routing],
    };
  });
};

const saveServices = async () => {
  if (!offer) {
    return;
  }

  if (!servicesForm.mainField.length) {
    setServicesError(
      "Wybierz przynajmniej jedną kategorię"
    );
    return;
  }

  try {
    setSavingServices(true);
    setServicesError("");

    await dispatch(
      updateAdminOfferServices({
        id,
        mainField: servicesForm.mainField,
        isADR: servicesForm.isADR,
        isInternational:
          servicesForm.isInternational,
        isOversized:
          servicesForm.isOversized,
      })
    ).unwrap();

    setEditingServices(false);
  } catch (err) {
    setServicesError(
      typeof err === "string"
        ? err
        : "Nie udało się zapisać usług"
    );
  } finally {
    setSavingServices(false);
  }
};

  /*
   * ADRES
   */

  const startAddressEdit =
    () => {
      if (!offer) {
        return;
      }

      setAddressForm({
        street: String(
          offer.street || ""
        ),

        streetNumber:
          String(
            offer.streetNumber ??
              ""
          ),

        localNumber:
          String(
            offer.localNumber ??
              ""
          ),

        zipCode: String(
          offer.zipCode || ""
        ),

        city: String(
          offer.city || ""
        ),

        voivodeship:
          String(
            offer.voivodeship ||
              ""
          ),
      });

      setAddressError("");
      setEditingAddress(true);
    };

  const cancelAddressEdit =
    () => {
      if (savingAddress) {
        return;
      }

      setEditingAddress(false);
      setAddressError("");
    };

  const saveAddress =
    async () => {
      const street =
        String(
          addressForm.street ??
            ""
        ).trim();

      const streetNumber =
        String(
          addressForm.streetNumber ??
            ""
        ).trim();

      const localNumber =
        String(
          addressForm.localNumber ??
            ""
        ).trim();

      const zipCode =
        String(
          addressForm.zipCode ??
            ""
        ).trim();

      const city =
        String(
          addressForm.city ??
            ""
        ).trim();

      const voivodeship =
        String(
          addressForm.voivodeship ??
            ""
        ).trim();

      if (
        !street ||
        !streetNumber ||
        !zipCode ||
        !city ||
        !voivodeship
      ) {
        setAddressError(
          "Uzupełnij wymagane dane adresowe"
        );

        return;
      }

      try {
        setSavingAddress(true);
        setAddressError("");

        await dispatch(
          updateAdminOfferAddress({
            id,
            street,
            streetNumber,
            localNumber:
              localNumber || null,
            zipCode,
            city,
            voivodeship,
          })
        ).unwrap();

        setEditingAddress(false);
      } catch (err) {
        setAddressError(
          typeof err === "string"
            ? err
            : "Nie udało się zmienić adresu"
        );
      } finally {
        setSavingAddress(false);
      }
    };

  /*
   * OPIS
   */
    
    const startDescriptionEdit = () => {
    if (!offer) {
      return;
    }

    setDescriptionForm(
      offer.description || ""
    );

    setDescriptionError("");
    setEditingDescription(true);
  };

  const cancelDescriptionEdit = () => {
    if (savingDescription) {
      return;
    }

    setEditingDescription(false);
    setDescriptionError("");
  };

  const saveDescription = async () => {
    const description =
      descriptionForm.trim();

    if (!description) {
      setDescriptionError(
        "Opis firmy nie może być pusty"
      );
      return;
    }

    try {
      setSavingDescription(true);
      setDescriptionError("");

      await dispatch(
        updateAdminOfferDescription({
          id,
          description,
        })
      ).unwrap();

      setEditingDescription(false);
    } catch (err) {
      setDescriptionError(
        typeof err === "string"
          ? err
          : "Nie udało się zapisać opisu"
      );
    } finally {
      setSavingDescription(false);
    }
  };
  /*
   * AKTYWACJA
   */

  const activateOffer =
    async () => {
      if (!offer) {
        return;
      }

      try {
        setActivating(true);
        setActivateError("");

        await dispatch(
          activateAdminOffer(
            offer._id
          )
        ).unwrap();
      } catch (err) {
        setActivateError(
          typeof err === "string"
            ? err
            : "Nie udało się aktywować wizytówki"
        );
      } finally {
        setActivating(false);
      }
    };

  const deactivateOffer =
    async () => {
      if (!offer) {
        return;
      }

      try {
        setDeactivating(true);
        setDeactivateError("");

        await dispatch(
          deactivateAdminOffer(
            offer._id
          )
        ).unwrap();
      } catch (err) {
        setDeactivateError(
          typeof err === "string"
            ? err
            : "Nie udało się dezaktywować wizytówki"
        );
      } finally {
        setDeactivating(false);
      }
    };
    
    const activateFreePeriod =
      async () => {
        if (!offer) {
          return;
        }

        try {
          setActivatingFreePeriod(true);
          setFreePeriodError("");

          await dispatch(
            activateAdminOfferFreePeriod(
              offer._id
            )
          ).unwrap();
        } catch (err) {
          setFreePeriodError(
            typeof err === "string"
              ? err
              : "Nie udało się aktywować darmowego okresu"
          );
        } finally {
          setActivatingFreePeriod(false);
        }
      };

      const grantBenefit = async () => {
        if (!offer) {
          return;
        }

        if (
          benefitForm.periodYears === 0 &&
          benefitForm.highlightedMonths === 0 &&
          benefitForm.recommendedMonths === 0
        ) {
          setBenefitError(
            "Wybierz przynajmniej jeden benefit"
          );
          setBenefitSuccess("");
          return;
        }

        try {
          setGrantingBenefit(true);
          setBenefitError("");
          setBenefitSuccess("");

          await dispatch(
            grantAdminOfferBenefit({
              id: offer._id,
              data: {
                periodYears:
                  benefitForm.periodYears,
                highlightedMonths:
                  benefitForm.highlightedMonths,
                recommendedMonths:
                  benefitForm.recommendedMonths,
                note:
                  benefitForm.note.trim(),
              },
            })
          ).unwrap();

          setBenefitForm({
            periodYears: 0,
            highlightedMonths: 0,
            recommendedMonths: 0,
            note: "",
          });

          setBenefitSuccess(
            "Benefit został przyznany"
          );
        } catch (err) {
          setBenefitError(
            typeof err === "string"
              ? err
              : "Nie udało się przyznać benefitu"
          );
        } finally {
          setGrantingBenefit(false);
        }
      };
  /*
   * LOADING
   */

  if (loading && !offer) {
    return (
      <PageLayout>
        <div
          className={
            styles.Message
          }
        >
          Pobieranie wizytówki...
        </div>
      </PageLayout>
    );
  }

if (!offer) {
  return (
    <PageLayout>
      <div className={styles.Error}>
        Nie znaleziono wizytówki
      </div>
    </PageLayout>
  );
}

  return (
    <PageLayout
      className={
        styles.OfferDetails
      }
    >
      {/* POWRÓT */}

      <button
        type="button"
        className={
          styles.BackButton
        }
        onClick={() =>
          history.push(
            "/admin/offers"
          )
        }
      >
        ← Wróć do wizytówek
      </button>

      {/* HEADER */}

      <div
        className={
          styles.Header
        }
      >
        <div>
          <h1
            className={
              styles.Title
            }
          >
            {offer.name}
          </h1>

          <div
            className={
              styles.Nip
            }
          >
            NIP: {offer.NIP}
          </div>
        </div>

        <div
          className={
            styles.Actions
          }
        >
          <Button
            variant="contained"
            size="small"
            onClick={
              openOwnerModal
            }
          >
            {offer.isAssigned
              ? "Zmień właściciela"
              : "Przypisz właściciela"}
          </Button>

          {!offer.isActive &&
            !offer.hasBills &&
            !offer.addDate &&
            !offer.expirationDate &&
            !offer.period && (
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={activateFreePeriod}
                disabled={activatingFreePeriod}
              >
                {activatingFreePeriod
                  ? "Aktywowanie..."
                  : "Aktywuj darmowy okres"}
              </Button>
            )}

          {!offer.isActive &&
            (
              offer.addDate ||
              offer.expirationDate ||
              offer.period
            ) && (
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={activateOffer}
                disabled={activating}
              >
                {activating
                  ? "Aktywowanie..."
                  : "Aktywuj"}
              </Button>
            )}

          {offer.isActive && (
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={deactivateOffer}
              disabled={deactivating}
            >
              {deactivating
                ? "Dezaktywowanie..."
                : "Dezaktywuj"}
            </Button>
          )}
        </div>
      </div>

      {activateError && (
        <div
          className={
            styles.StatusError
          }
        >
          {activateError}
        </div>
      )}

      {deactivateError && (
        <div
          className={
            styles.StatusError
          }
        >
          {deactivateError}
        </div>
      )}
      {/* GRID */}

      <div
        className={
          styles.Grid
        }
      >

      {freePeriodError && (
        <div
          className={
            styles.StatusError
          }
        >
          {freePeriodError}
        </div>
      )}  

        {/* WŁAŚCICIEL */}

        <div
          className={
            styles.Card
          }
        >
          <div
            className={
              styles.CardTitle
            }
          >
            Właściciel
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>E-mail</span>

            <strong>
              {offer.user || "-"}
            </strong>
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>
              Przypisanie
            </span>

            <strong>
              {offer.isAssigned
                ? "Przypisana"
                : "Nieprzypisana"}
            </strong>
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>
              Utworzona przez
            </span>

            <strong>
              {offer.createdBy ||
                "-"}
            </strong>
          </div>
        </div>

        {/* STATUS */}

        <div
          className={
            styles.Card
          }
        >
          <div
            className={
              styles.CardTitle
            }
          >
            Status wizytówki
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>Status</span>

            <strong>
              {getStatus()}
            </strong>
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>Dodana</span>

            <strong>
              {formatDate(
                offer.addDate
              )}
            </strong>
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>
              Ważna do
            </span>

            <strong>
              {formatDate(
                offer.expirationDate
              )}
            </strong>
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>Okres</span>

            <strong>
              {offer.period
                ? `${offer.period} ${
                    offer.period ===
                    1
                      ? "rok"
                      : "lata"
                  }`
                : "-"}
            </strong>
          </div>
        </div>

        {/* DANE FIRMY */}

        <div className={styles.Card}>
          <div className={styles.CardHeader}>
            <div className={styles.CardTitle}>
              Dane firmy
            </div>

            {!editingCompanyData && (
              <Button
                variant="outlined"
                size="small"
                onClick={startCompanyDataEdit}
              >
                Edytuj
              </Button>
            )}
          </div>

          {editingCompanyData ? (
            <>
              <div className={styles.AddressForm}>
                <TextField
                  label="Nazwa"
                  size="small"
                  fullWidth
                  value={companyDataForm.name}
                  onChange={(e) =>
                    setCompanyDataForm({
                      ...companyDataForm,
                      name: e.target.value,
                    })
                  }
                />

                <TextField
                  label="Nazwa skrócona"
                  size="small"
                  fullWidth
                  value={companyDataForm.shortName}
                  onChange={(e) =>
                    setCompanyDataForm({
                      ...companyDataForm,
                      shortName: e.target.value,
                    })
                  }
                />

                <TextField
                  label="E-mail"
                  size="small"
                  fullWidth
                  value={companyDataForm.email}
                  onChange={(e) =>
                    setCompanyDataForm({
                      ...companyDataForm,
                      email: e.target.value,
                    })
                  }
                />

                <TextField
                  label="Telefon"
                  size="small"
                  fullWidth
                  value={companyDataForm.phone}
                  onChange={(e) =>
                    setCompanyDataForm({
                      ...companyDataForm,
                      phone: e.target.value,
                    })
                  }
                />

                <TextField
                  label="WWW"
                  size="small"
                  fullWidth
                  value={companyDataForm.website}
                  onChange={(e) =>
                    setCompanyDataForm({
                      ...companyDataForm,
                      website: e.target.value,
                    })
                  }
                />
              </div>

              {companyDataError && (
                <div className={styles.EditError}>
                  <span>{companyDataError}</span>

                  <IconButton
                    size="small"
                    onClick={() =>
                      setCompanyDataError("")
                    }
                    aria-label="Zamknij komunikat"
                    sx={{
                      marginLeft: "auto",
                      color: "error.main",
                      width: 28,
                      height: 28,
                    }}
                  >
                    ×
                  </IconButton>
                </div>
              )}

              <div className={styles.EditActions}>
                <Button
                  variant="text"
                  size="small"
                  onClick={cancelCompanyDataEdit}
                  disabled={savingCompanyData}
                >
                  Anuluj
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  onClick={saveCompanyData}
                  disabled={savingCompanyData}
                >
                  {savingCompanyData
                    ? "Zapisywanie..."
                    : "Zapisz"}
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className={styles.Row}>
                <span>Nazwa</span>
                <strong>{offer.name}</strong>
              </div>

              <div className={styles.Row}>
                <span>Nazwa skrócona</span>
                <strong>
                  {offer.shortName || "-"}
                </strong>
              </div>

              <div className={styles.Row}>
                <span>E-mail</span>
                <strong>{offer.email}</strong>
              </div>

              <div className={styles.Row}>
                <span>Telefon</span>
                <strong>{offer.phone}</strong>
              </div>

              <div className={styles.Row}>
                <span>WWW</span>
                <strong>
                  {offer.website || "-"}
                </strong>
              </div>
            </>
          )}
        </div>

        {/* ADRES */}

        <div
          className={
            styles.Card
          }
        >
          <div
            className={
              styles.CardHeader
            }
          >
            <div
              className={
                styles.CardTitle
              }
            >
              Adres
            </div>

            {!editingAddress && (
              <Button
                variant="outlined"
                size="small"
                onClick={
                  startAddressEdit
                }
              >
                Edytuj
              </Button>
            )}
          </div>

          {editingAddress ? (
            <>
              <div
                className={
                  styles.AddressForm
                }
              >
                <TextField
                  label="Ulica"
                  size="small"
                  fullWidth
                  value={
                    addressForm.street
                  }
                  onChange={(e) =>
                    setAddressForm({
                      ...addressForm,
                      street:
                        e.target.value,
                    })
                  }
                />

                <div
                  className={
                    styles.AddressNumbers
                  }
                >
                  <TextField
                    label="Numer budynku"
                    size="small"
                    fullWidth
                    value={
                      addressForm.streetNumber
                    }
                    onChange={(e) =>
                      setAddressForm({
                        ...addressForm,
                        streetNumber:
                          e.target.value,
                      })
                    }
                  />

                  <TextField
                    label="Numer lokalu"
                    size="small"
                    fullWidth
                    value={
                      addressForm.localNumber
                    }
                    onChange={(e) =>
                      setAddressForm({
                        ...addressForm,
                        localNumber:
                          e.target.value,
                      })
                    }
                  />
                </div>

                <div
                  className={
                    styles.AddressLocation
                  }
                >
                  <TextField
                    label="Kod pocztowy"
                    size="small"
                    fullWidth
                    value={
                      addressForm.zipCode
                    }
                    onChange={(e) =>
                      setAddressForm({
                        ...addressForm,
                        zipCode:
                          e.target.value,
                      })
                    }
                  />

                  <TextField
                    label="Miasto"
                    size="small"
                    fullWidth
                    value={
                      addressForm.city
                    }
                    onChange={(e) =>
                      setAddressForm({
                        ...addressForm,
                        city:
                          e.target.value,
                      })
                    }
                  />
                </div>

                <FormControl fullWidth size="small">
                  <InputLabel>Województwo</InputLabel>

                  <Select
                    value={addressForm.voivodeship}
                    label="Województwo"
                    onChange={(e) =>
                      setAddressForm({
                        ...addressForm,
                        voivodeship: String(e.target.value),
                      })
                    }
                  >
                    {vvship
                      .filter((v) => v.value !== "All")
                      .map((v) => (
                        <MenuItem
                          key={v.key}
                          value={v.value}
                        >
                          {v.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>

              {addressError && (
                <div className={styles.EditError}>
                  <span>{addressError}</span>

                      <IconButton
                        size="small"
                        onClick={() => setAddressError("")}
                        aria-label="Zamknij komunikat"
                        sx={{
                          marginLeft: "auto",
                          color: "error.main",
                          width: 28,
                          height: 28,
                        }}
                      >
                        ×
                      </IconButton>
                </div>
              )}

              <div
                className={
                  styles.EditActions
                }
              >
                <Button
                  variant="text"
                  size="small"
                  onClick={
                    cancelAddressEdit
                  }
                  disabled={
                    savingAddress
                  }
                >
                  Anuluj
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  onClick={
                    saveAddress
                  }
                  disabled={
                    savingAddress
                  }
                >
                  {savingAddress
                    ? "Zapisywanie..."
                    : "Zapisz"}
                </Button>
              </div>
            </>
          ) : (
            <>
              <div
                className={
                  styles.Row
                }
              >
                <span>Ulica</span>

                <strong>
                  {offer.street}{" "}
                  {offer.streetNumber}

                  {offer.localNumber
                    ? `/${offer.localNumber}`
                    : ""}
                </strong>
              </div>

              <div
                className={
                  styles.Row
                }
              >
                <span>
                  Kod pocztowy
                </span>

                <strong>
                  {offer.zipCode}
                </strong>
              </div>

              <div
                className={
                  styles.Row
                }
              >
                <span>Miasto</span>

                <strong>
                  {offer.city}
                </strong>
              </div>

              <div
                className={
                  styles.Row
                }
              >
                <span>
                  Województwo
                </span>

                <strong>
                  {vvship.find(
                    (v) =>
                      v.value === offer.voivodeship
                  )?.title || offer.voivodeship}
                </strong>
              </div>

              <div
                className={
                  styles.Row
                }
              >
                <span>
                  Współrzędne
                </span>

                <div
                  className={
                    styles.CoordinatesValue
                  }
                >
                  <strong>
                    {hasCoordinates
                      ? `${offer.coordinates[0]}, ${offer.coordinates[1]}`
                      : "Brak"}
                  </strong>

                  {hasCoordinates && (
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() =>
                        setMapModalOpen(
                          true
                        )
                      }
                    >
                      Pokaż na mapie
                    </Button>
                  )}
                </div>
              </div>
            </>
          )}
        </div>

        {/* USŁUGI */}

        <div className={styles.Card}>
          <div className={styles.CardHeader}>
            <div className={styles.CardTitle}>
              Usługi
            </div>

            {!editingServices && (
              <Button
                variant="outlined"
                size="small"
                onClick={startServicesEdit}
              >
                Edytuj
              </Button>
            )}
          </div>

          {editingServices ? (
            <>
              <div className={styles.AddressForm}>
                <div>
                  <strong>Kategorie</strong>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(2, minmax(0, 1fr))",
                      marginTop: "8px",
                    }}
                  >
                    {icons.map((icon) => (
                      <FormControlLabel
                        key={icon.routing}
                        control={
                          <Checkbox
                            checked={servicesForm.mainField.includes(
                              icon.routing
                            )}
                            onChange={() =>
                              toggleServiceCategory(
                                icon.routing
                              )
                            }
                          />
                        }
                        label={icon.title}
                      />
                    ))}
                  </div>
                </div>

                <div>
                  <strong>Rodzaj usług</strong>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "8px",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={servicesForm.isADR}
                          onChange={(e) =>
                            setServicesForm(
                              (current) => ({
                                ...current,
                                isADR:
                                  e.target.checked,
                              })
                            )
                          }
                        />
                      }
                      label="Transport ADR"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            servicesForm.isOversized
                          }
                          onChange={(e) =>
                            setServicesForm(
                              (current) => ({
                                ...current,
                                isOversized:
                                  e.target.checked,
                              })
                            )
                          }
                        />
                      }
                      label="Transport ponadnormatywny"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            servicesForm.isInternational
                          }
                          onChange={(e) =>
                            setServicesForm(
                              (current) => ({
                                ...current,
                                isInternational:
                                  e.target.checked,
                              })
                            )
                          }
                        />
                      }
                      label="Transport międzynarodowy"
                    />
                  </div>
                </div>
              </div>

              {servicesError && (
                <div className={styles.EditError}>
                  {servicesError}
                </div>
              )}

              <div className={styles.EditActions}>
                <Button
                  variant="text"
                  size="small"
                  onClick={cancelServicesEdit}
                  disabled={savingServices}
                >
                  Anuluj
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  onClick={saveServices}
                  disabled={savingServices}
                >
                  {savingServices
                    ? "Zapisywanie..."
                    : "Zapisz"}
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className={styles.Row}>
                <span>Kategorie</span>

                <strong>
                  {offer.mainField?.length
                    ? offer.mainField
                        .map((field) => {
                          const category =
                            icons.find(
                              (item) =>
                                item.routing ===
                                field
                            );

                          return (
                            category?.title ||
                            field
                          );
                        })
                        .join(", ")
                    : "-"}
                </strong>
              </div>

              <div className={styles.Row}>
                <span>Transport ADR</span>
                <strong>
                  {offer.isADR ? "Tak" : "Nie"}
                </strong>
              </div>

              <div className={styles.Row}>
                <span>
                  Transport ponadnormatywny
                </span>
                <strong>
                  {offer.isOversized
                    ? "Tak"
                    : "Nie"}
                </strong>
              </div>

              <div className={styles.Row}>
                <span>
                  Transport międzynarodowy
                </span>
                <strong>
                  {offer.isInternational
                    ? "Tak"
                    : "Nie"}
                </strong>
              </div>
            </>
          )}
        </div>

        {/* PROMOWANIE */}

        <div
          className={
            styles.Card
          }
        >
          <div
            className={
              styles.CardTitle
            }
          >
            Promowanie
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>
              Wyróżniona
            </span>

            <strong>
              {offer.highlightedExpirationDate &&
              new Date(offer.highlightedExpirationDate) > new Date()
                ? "Tak"
                : "Nie"}
            </strong>
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>
              Wyróżnienie do
            </span>

            <strong>
              {formatDate(
                offer.highlightedExpirationDate
              )}
            </strong>
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>Polecana</span>

            <strong>
              {offer.recommendedExpirationDate &&
              new Date(offer.recommendedExpirationDate) > new Date()
                ? "Tak"
                : "Nie"}
            </strong>
          </div>

          <div
            className={
              styles.Row
            }
          >
            <span>
              Polecana do
            </span>

            <strong>
              {formatDate(
                offer.recommendedExpirationDate
              )}
            </strong>
          </div>
        </div>

        {/* BENEFITY */}
        
          <div className={styles.Card}>
            <div className={styles.CardTitle}>
              Przyznaj benefit
            </div>
          <div className={styles.BenefitForm}>
            <FormControl
              fullWidth
              size="small"
            >
              <InputLabel>
                Okres publikacji
              </InputLabel>

              <Select
                value={
                  benefitForm.periodYears
                }
                label="Okres publikacji"
                onChange={(e) => {
                  setBenefitForm({
                    ...benefitForm,
                    periodYears: Number(
                      e.target.value
                    ),
                  });
                  setBenefitError("");
                  setBenefitSuccess("");
                }}
              >
                <MenuItem value={0}>
                  Nie dodawaj
                </MenuItem>
                <MenuItem value={1}>
                  +1 rok
                </MenuItem>
                <MenuItem value={2}>
                  +2 lata
                </MenuItem>
                <MenuItem value={3}>
                  +3 lata
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              size="small"
            >
              <InputLabel>
                Wyróżnienie
              </InputLabel>

              <Select
                value={
                  benefitForm.highlightedMonths
                }
                label="Wyróżnienie"
                onChange={(e) => {
                  setBenefitForm({
                    ...benefitForm,
                    highlightedMonths: Number(
                      e.target.value
                    ),
                  });
                  setBenefitError("");
                  setBenefitSuccess("");
                }}
              >
                <MenuItem value={0}>
                  Nie dodawaj
                </MenuItem>
                <MenuItem value={1}>
                  +1 miesiąc
                </MenuItem>
                <MenuItem value={2}>
                  +2 miesiące
                </MenuItem>
                <MenuItem value={3}>
                  +3 miesiące
                </MenuItem>
                <MenuItem value={6}>
                  +6 miesięcy
                </MenuItem>
                <MenuItem value={12}>
                  +12 miesięcy
                </MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              size="small"
            >
              <InputLabel>
                TOP3
              </InputLabel>

              <Select
                value={
                  benefitForm.recommendedMonths
                }
                label="TOP3"
                onChange={(e) => {
                  setBenefitForm({
                    ...benefitForm,
                    recommendedMonths: Number(
                      e.target.value
                    ),
                  });
                  setBenefitError("");
                  setBenefitSuccess("");
                }}
              >
                <MenuItem value={0}>
                  Nie dodawaj
                </MenuItem>
                <MenuItem value={1}>
                  +1 miesiąc
                </MenuItem>
                <MenuItem value={2}>
                  +2 miesiące
                </MenuItem>
                <MenuItem value={3}>
                  +3 miesiące
                </MenuItem>
                <MenuItem value={6}>
                  +6 miesięcy
                </MenuItem>
                <MenuItem value={12}>
                  +12 miesięcy
                </MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Notatka"
              size="small"
              fullWidth
              multiline
              minRows={2}
              value={benefitForm.note}
              onChange={(e) =>
                setBenefitForm({
                  ...benefitForm,
                  note: e.target.value,
                })
              }
            />

            {benefitError && (
              <div className={styles.StatusError}>
                {benefitError}
              </div>
            )}

            {benefitSuccess && (
              <div>
                {benefitSuccess}
              </div>
            )}

            <Button
              variant="contained"
              size="small"
              onClick={grantBenefit}
              disabled={grantingBenefit}
            >
              {grantingBenefit
                ? "Przyznawanie..."
                : "Przyznaj benefit"}
            </Button>
          </div>
        </div>
        
        {/* HISTORIA BENEFITÓW */}

        <div className={styles.Card}>
          <div className={styles.CardTitle}>
            Historia benefitów
          </div>

          {!offer.benefits?.length ? (
            <div>
              Brak przyznanych benefitów
            </div>
          ) : (
            <div className={styles.BenefitsHistory}>
              {[...offer.benefits]
                .reverse()
                .map((benefit, index) => (
                  <div
                    key={index}
                    className={styles.BenefitHistoryItem}
                  >
                    <strong>
                      {benefit.type === "period"
                        ? "Publikacja"
                        : benefit.type === "highlighted"
                        ? "Wyróżnienie"
                        : "TOP3"}
                    </strong>

                    <div>
                      +{benefit.value}{" "}
                      {benefit.unit === "years"
                        ? benefit.value === 1
                          ? "rok"
                          : "lata"
                        : benefit.value === 1
                        ? "miesiąc"
                        : "miesiące"}
                    </div>

                    <div>
                      {formatDate(
                        benefit.grantedAt
                      )}
                    </div>

                    <div>
                      {benefit.source ===
                      "registration_free"
                        ? "Darmowa rejestracja"
                        : "Przyznane przez admina"}
                    </div>

                    {benefit.grantedBy && (
                      <div>
                        Admin:{" "}
                        {benefit.grantedBy}
                      </div>
                    )}

                    {benefit.note && (
                      <div>
                        Notatka:{" "}
                        {benefit.note}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
      {/* OPIS FIRMY */}

      <div className={styles.Card}>
        <div className={styles.CardHeader}>
          <div className={styles.CardTitle}>
            Opis firmy
          </div>

          {!editingDescription && (
            <Button
              variant="outlined"
              size="small"
              onClick={startDescriptionEdit}
            >
              Edytuj
            </Button>
          )}
        </div>

        {editingDescription ? (
          <>
            <TextField
              label="Opis firmy"
              value={descriptionForm}
              onChange={(e) =>
                setDescriptionForm(
                  e.target.value
                )
              }
              multiline
              minRows={6}
              fullWidth
            />

            {descriptionError && (
              <div className={styles.EditError}>
                {descriptionError}
              </div>
            )}

            <div className={styles.EditActions}>
              <Button
                variant="text"
                size="small"
                onClick={cancelDescriptionEdit}
                disabled={savingDescription}
              >
                Anuluj
              </Button>

              <Button
                variant="contained"
                size="small"
                onClick={saveDescription}
                disabled={savingDescription}
              >
                {savingDescription
                  ? "Zapisywanie..."
                  : "Zapisz"}
              </Button>
            </div>
          </>
        ) : (
          <div>
            {offer.description || "-"}
          </div>
        )}
      </div>

      {/* MAPA */}

      {mapModalOpen &&
        hasCoordinates && (
          <div
            className={
              styles.ModalOverlay
            }
            onMouseDown={() =>
              setMapModalOpen(
                false
              )
            }
          >
            <div
              className={
                styles.MapModal
              }
              onMouseDown={(e) =>
                e.stopPropagation()
              }
            >
              <div
                className={
                  styles.MapModalHeader
                }
              >
                <div>
                  <div
                    className={
                      styles.ModalTitle
                    }
                  >
                    Lokalizacja firmy
                  </div>

                  <div
                    className={
                      styles.MapAddress
                    }
                  >
                    {offer.street}{" "}
                    {offer.streetNumber}

                    {offer.localNumber
                      ? `/${offer.localNumber}`
                      : ""}
                    ,{" "}
                    {offer.zipCode}{" "}
                    {offer.city}
                  </div>
                </div>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={() =>
                    setMapModalOpen(
                      false
                    )
                  }
                >
                  Zamknij
                </Button>
              </div>

              <div
                className={
                  styles.MapContainer
                }
              >
                <MapContainer
                  center={[
                    Number(
                      offer.coordinates[0]
                    ),
                    Number(
                      offer.coordinates[1]
                    ),
                  ]}
                  zoom={16}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  />

                  <Marker
                    position={[
                      Number(
                        offer.coordinates[0]
                      ),
                      Number(
                        offer.coordinates[1]
                      ),
                    ]}
                    icon={
                      mapIcons[
                        `${offer.mainField[0]}`
                      ]
                    }
                  >
                    <Popup>
                      <strong>
                        {offer.name}
                      </strong>

                      <br />

                      {offer.city},{" "}
                      {offer.street}{" "}
                      {offer.streetNumber}

                      {offer.localNumber
                        ? `/${offer.localNumber}`
                        : ""}
                    </Popup>
                  </Marker>
                </MapContainer>
              </div>

              <div
                className={
                  styles.MapCoordinates
                }
              >
                Współrzędne:{" "}
                <strong>
                  {offer.coordinates[0]}
                  ,{" "}
                  {offer.coordinates[1]}
                </strong>
              </div>
            </div>
          </div>
        )}

      {/* MODAL WŁAŚCICIELA */}

      {ownerModalOpen && (
        <div
          className={
            styles.ModalOverlay
          }
          onMouseDown={
            closeOwnerModal
          }
        >
          <div
            className={
              styles.Modal
            }
            onMouseDown={(e) =>
              e.stopPropagation()
            }
          >
            <div
              className={
                styles.ModalTitle
              }
            >
              {offer.isAssigned
                ? "Zmień właściciela"
                : "Przypisz właściciela"}
            </div>

            <div
              className={
                styles.ModalText
              }
            >
              Wybierz istniejącego
              użytkownika lub wpisz
              dowolny adres e-mail.
            </div>

            <TextField
              id="ownerEmail"
              type="email"
              label="E-mail właściciela"
              variant="outlined"
              size="small"
              fullWidth
              value={
                ownerEmail
              }
              inputProps={{
                list: "admin-users",
              }}
              onChange={(e) => {
                setOwnerEmail(
                  e.target.value
                );

                setOwnerError("");
              }}
              onKeyDown={(e) => {
                if (
                  e.key ===
                    "Enter" &&
                  !savingOwner
                ) {
                  saveOwner();
                }
              }}
              error={Boolean(
                ownerError
              )}
              helperText={
                ownerError || " "
              }
              autoFocus
            />

            <datalist id="admin-users">
              {users.map(
                (user) => (
                  <option
                    key={
                      user._id
                    }
                    value={
                      user.email
                    }
                  />
                )
              )}
            </datalist>

            <div
              className={
                styles.ModalActions
              }
            >
              <Button
                variant="text"
                onClick={
                  closeOwnerModal
                }
                disabled={
                  savingOwner
                }
              >
                Anuluj
              </Button>

              <Button
                variant="contained"
                onClick={
                  saveOwner
                }
                disabled={
                  savingOwner
                }
              >
                {savingOwner
                  ? "Zapisywanie..."
                  : "Zapisz"}
              </Button>
            </div>
          </div>
        </div>
      )}
    </PageLayout>
  );
};

export default OfferDetails;